// @ts-nocheck

import {
    getSidebarOverlayFromElement,
    SidebarOverlay,
} from "@legacy/modules/sidebar-overlay.module.ts";

// Инициализация элементов sidebar-overlay
document
    .querySelectorAll("[data-sidebar-overlay]")
    .forEach(
        (element) => new SidebarOverlay(/** @type {HTMLElement} */ element),
    );

// Открытие сайдбара при клике на элемент с атрибутом data-sidebar-overlay-open
document.querySelectorAll("[data-sidebar-overlay-open]").forEach((openEl) => {
    if (!(openEl instanceof HTMLElement)) {
        return;
    }
    openEl.addEventListener("click", () => {
        const sidebarId = openEl.dataset.sidebarOverlayId;
        if (sidebarId === undefined) {
            return;
        }
        const sidebarElement = document.querySelector(`#${sidebarId}`);
        if (!(sidebarElement instanceof HTMLElement)) {
            return;
        }
        const sidebar = getSidebarOverlayFromElement(sidebarElement);
        if (sidebar !== undefined) {
            sidebar.open();
        }
    });
});
